import { useContext, useCallback, useState } from 'react';

import { formatListData, AjaxContext, UserContext, MerchantContext } from 'commons-ui';
import { IApp, IPageDetails, IPermission } from '../../../../../models/settingsV2.model';
import { permissionUrlPrefix, RESOURCES, SETTINGS_V2_ACTION } from '../../../../../settingsV2Constant';
import { SERVICE_NAMES } from '../../../../../settingsV2Enum';

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const { user } = useContext(UserContext);
	const [forceUpdate, setForceUpdate] = useState(false);
	const { merchantName } = useContext(MerchantContext);
	const turnForceUpdateOff = () => {
		setForceUpdate(false);
	};

	const requestCreatePermissions = useCallback((appName: string, data: IPermission) => {
		return postData({
			endpoint: `${permissionUrlPrefix}-createPermission`,
			body: {
				...data,
				updatedBy: user?.email,
				createdAt: Date.now(),
				updatedAt: Date.now(),
				userMerchant: merchantName,
				forwardReqRoute: `/dashboard/${RESOURCES.permission}/${SETTINGS_V2_ACTION.createPermission}`,
				forwardReqToService: SERVICE_NAMES.AUTH
			},
			queryParams: {
				appName
			}
		});
	}, []);

	const getPermissionsData = useCallback(async ({ app, pageDetails }: { app: IApp; pageDetails: IPageDetails }) => {
		const res = await postData({
			endpoint: `${permissionUrlPrefix}-listPermission`,
			body: {
				pageNo: pageDetails.pageNo,
				pageSize: pageDetails.pageSize,
				userMerchant: merchantName,
				forwardReqRoute: `/dashboard/${RESOURCES.permission}/${SETTINGS_V2_ACTION.listPermission}`,
				forwardReqToService: SERVICE_NAMES.AUTH
			},
			queryParams: {
				appName: app.appName
			}
		});
		const listData: IPermission = formatListData(res?.data?.data?.permissions);
		return { rowCount: res?.data?.data?.permissionCount, data: listData };
	}, []);

	const requestUpdatePermissions = useCallback((appName: string, data: IPermission) => {
		return postData({
			endpoint: `${permissionUrlPrefix}-editPermission`,
			body: {
				permissionId: data._id,
				description: data.description,
				forwardReqRoute: `/dashboard/${RESOURCES.permission}/${SETTINGS_V2_ACTION.editPermission}`,
				forwardReqToService: SERVICE_NAMES.AUTH
			},
			queryParams: {
				appName
			}
		});
	}, []);

	const requestDeletePermissions = useCallback((appName: string, data: IPermission) => {
		return postData({
			endpoint: `${permissionUrlPrefix}-deletePermission`,
			body: {
				permissionId: data._id,
				forwardReqRoute: `/dashboard/${RESOURCES.permission}/${SETTINGS_V2_ACTION.deletePermission}`,
				forwardReqToService: SERVICE_NAMES.AUTH
			},
			queryParams: {
				appName
			}
		});
	}, []);

	return {
		requestCreatePermissions,
		getPermissionsData,
		requestUpdatePermissions,
		requestDeletePermissions,
		forceUpdate,
		setForceUpdate,
		turnForceUpdateOff
	};
};

export default useService;
